import { Paragraph } from 'docx';

// Utils
import { isEmptyValueArray } from '@shared/utils';
import { filterValidSkills } from '@/utils/resume';
import {
  bodyRun,
  bulletParagraph,
  sectionHeading,
  sectionSpacer,
} from '../utils';

// Types
import { TemplateProps } from '@/components/template/resume/type';

// Tokens
import { SECTION_TITLES } from '../../tokens';

export const TechnicalSkillsSection = (
  skills: TemplateProps['data']['technicalSkills'],
): Paragraph[] => {
  const filtered = filterValidSkills(skills ?? []);
  if (isEmptyValueArray(filtered)) return [];

  return [
    sectionHeading(SECTION_TITLES.technicalSkills),
    ...filtered.map(({ name: categoryName = '', items = [] }) => {
      const skillText = items.filter(Boolean).join(', ');
      const separator = categoryName && skillText ? ': ' : '';

      return bulletParagraph([
        bodyRun(categoryName, { bold: true }),
        bodyRun(`${separator}${skillText}`),
      ]);
    }),
    sectionSpacer(),
  ];
};
